import * as yup from "yup";

export const schema = yup.object().shape({
  username: yup.string(),
  password: yup.string().min(2, "Password must be at least 4 characters"),
});

export type LoginFormData = yup.InferType<typeof schema>;
